import React, { useState, useEffect } from "react";
import { Form, Input, Card, Typography, Row, Col, Space, Button } from "antd";
import { MailOutlined, PhoneOutlined, HomeOutlined } from "@ant-design/icons";
import { IconHeadset } from "@tabler/icons-react";
import { useLocation } from "react-router-dom";
import GlobalHeader from "../util/GlobalHeader";
import Navbar from "./Navbar";
import PublicServ from "../service/PublicServ";
import Notify from "../util/Notify";
import "../css/ContactPage.css";

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;

const ContactPage = () => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const location = useLocation();

    // Check if we are inside a dashboard (buyer, seller, or admin)
    const isInsideDashboard = location.pathname.startsWith("/buyer") ||
        location.pathname.startsWith("/seller") ||
        location.pathname.startsWith("/admin");

    useEffect(() => {
        const savedUser = localStorage.getItem("user");
        if (savedUser) {
            try {
                const user = JSON.parse(savedUser);
                form.setFieldsValue({
                    name: `${user.firstName} ${user.lastName}`,
                    email: user.email
                });
            } catch (e) {
                console.error("Error parsing user data", e);
            }
        }
    }, [form]);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await PublicServ.sendContactRequest(values);
            // Use just res.message if available
            Notify.success(res?.message || "Message sent successfully!");
            form.resetFields();
            // Refill user info after reset
            const savedUser = localStorage.getItem("user");
            if (savedUser) {
                const user = JSON.parse(savedUser);
                form.setFieldsValue({
                    name: `${user.firstName} ${user.lastName}`,
                    email: user.email
                });
            }
        } catch (error) {
            console.error(error);
            Notify.error(error, "Failed to send message. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const Wrapper = isInsideDashboard ? GlobalHeader : React.Fragment;
    const wrapperProps = isInsideDashboard ? {
        title: (
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, fontWeight: 800 }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 36, height: 36, borderRadius: 10, background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)', border: '1px solid rgba(139,92,246,0.25)' }}>
                    <IconHeadset size={20} color="#7c3aed" stroke={1.8} />
                </span>
                Support Center
            </span>
        )
    } : {};

    return (
        <div className={`contact-page-wrapper ${isInsideDashboard ? 'inside-dashboard' : ''}`}>
            {!isInsideDashboard && <Navbar />}
            <div className="contact-container">
                <Wrapper {...wrapperProps}>
                    <div className={isInsideDashboard ? "contact-content-inner" : ""}>
                        <div className="contact-header-section">
                            <span className="contact-small-tag">Contact Us</span>
                            <Title className="contact-huge-title">Get In Touch With Us</Title>
                            <Paragraph className="contact-description">
                                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco
                            </Paragraph>
                        </div>

                        <Row gutter={[40, 40]} align="stretch" justify="center" className="pcu-w-100 pcu-margin-y-0 contact-row">
                            <Col xs={24} lg={10} className="contact-info-col">
                                <div className="contact-info-panel">
                                    <div className="contact-info-list">
                                        <div className="contact-info-item">
                                            <div className="contact-info-icon-box">
                                                <HomeOutlined />
                                            </div>
                                            <div className="contact-info-text-box">
                                                <span className="contact-info-title">Our Location</span>
                                                <span className="contact-info-value">
                                                    99 S.t Jomblo Park Pekanbaru<br />28292. Indonesia
                                                </span>
                                            </div>
                                        </div>

                                        <div className="contact-info-item">
                                            <div className="contact-info-icon-box">
                                                <PhoneOutlined />
                                            </div>
                                            <div className="contact-info-text-box">
                                                <span className="contact-info-title">Phone Number</span>
                                                <span className="contact-info-value">+91-XXXXXXXXXX</span>
                                            </div>
                                        </div>

                                        <div className="contact-info-item">
                                            <div className="contact-info-icon-box">
                                                <MailOutlined />
                                            </div>
                                            <div className="contact-info-text-box">
                                                <span className="contact-info-title">Email Address</span>
                                                <span className="contact-info-value">support@nearzon.com</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col xs={24} lg={12}>
                                <div className="contact-right-container-relative">
                                    <div className="contact-deco-dots-tr"></div>
                                    <div className="contact-deco-pink"></div>
                                    <div className="contact-deco-dots-bl"></div>
                                    <Card className="contact-mock-form-card">
                                        <Form
                                            form={form}
                                            layout="vertical"
                                            onFinish={onFinish}
                                            requiredMark={false}
                                            className="contact-mock-form"
                                        >
                                            <Form.Item
                                                name="name"
                                                rules={[{ required: true, message: "Please enter your name" }]}
                                            >
                                                <Input
                                                    placeholder="Name"
                                                    className="contact-mock-input"
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="email"
                                                rules={[
                                                    { required: true, message: "Please enter your email" },
                                                    { type: "email", message: "Please enter a valid email" }
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Email"
                                                    className="contact-mock-input"
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="subject"
                                                rules={[{ required: true, message: "Please enter your phone number" }]}
                                            >
                                                <Input
                                                    placeholder="Phone"
                                                    className="contact-mock-input"
                                                />
                                            </Form.Item>

                                            <Form.Item
                                                name="message"
                                                rules={[{ required: true, message: "Please enter your message" }]}
                                            >
                                                <TextArea
                                                    placeholder="Message"
                                                    autoSize={{ minRows: 3, maxRows: 5 }}
                                                    className="contact-mock-textarea"
                                                />
                                            </Form.Item>

                                            <Form.Item style={{ marginBottom: 0 }}>
                                                <Button
                                                    type="primary"
                                                    htmlType="submit"
                                                    className="contact-mock-submit-btn"
                                                    loading={loading}
                                                    block
                                                >
                                                    Send Message
                                                </Button>
                                            </Form.Item>
                                        </Form>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Wrapper>
            </div>
        </div>
    );
};

export default ContactPage;
